import BaseComponent from '/webresources-sources/js/components/base-component';
import { defineComponent } from "/webresources-sources/js/util/jquery";

export default class GalleryComponent extends BaseComponent {
	events() {
		return {
			this: {
				'slick-carousel-init': (e) => {
					const slick = e.detail.slick;
					const $slick = e.detail.$slick;

					this.$element.find('[data-slide-count]').html(slick.slideCount);

					$slick.on('afterChange', (e, slick, currentSlide) => {
						this.$element.find('[data-active-slide]').html(currentSlide + 1);
					});
				},
			},
		};
	}
}

defineComponent('gallery-component', GalleryComponent);
